(() => {
  function initVideoControls() {
    const videoWrappers = document.querySelectorAll('.images-with-text-scroll__video-wrapper');
    
    videoWrappers.forEach((wrapper, index) => {
      const video = wrapper.querySelector('.images-with-text-scroll__video');
      const playPauseBtn = wrapper.querySelector('.play-pause-btn');
      const muteBtn = wrapper.querySelector('.mute-btn');
      
      if (!video) {
        return;
      }
      
      // Mark wrapper as processed to avoid duplicate event listeners
      if (wrapper.dataset.videoControlsInit) {
        return;
      }
      wrapper.dataset.videoControlsInit = 'true';
      
      // Set up intersection observer for auto-play on scroll
      setupIntersectionObserver(video, wrapper);
      
      // Initialize button states
      updatePlayPauseButton(video, playPauseBtn);
      if (muteBtn) updateMuteButton(video, muteBtn);
      
      // Play/Pause functionality
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          if (video.paused) {
            video.play().catch(() => {
              // Silent error handling - video may not be able to play
            });
          } else {
            video.pause();
          }
        });
      }
      
      // Mute/Unmute functionality
      if (muteBtn) {
        muteBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          video.muted = !video.muted;
          updateMuteButton(video, muteBtn);
        });
      }
      
      // Click on video to play/pause
      video.addEventListener('click', (e) => {
        e.stopPropagation();
        if (video.paused) {
          video.play().catch(console.error);
        } else {
          video.pause();
        }
      });
      
      // Update button states on video events
      video.addEventListener('play', () => updatePlayPauseButton(video, playPauseBtn));
      video.addEventListener('pause', () => updatePlayPauseButton(video, playPauseBtn));
      video.addEventListener('volumechange', () => {
        if (muteBtn) updateMuteButton(video, muteBtn);
      });
      
      // Handle autoplay with browser restrictions
      const shouldAutoplay = video.hasAttribute('autoplay');
      
      if (shouldAutoplay) {
        // Smart autoplay strategy: try unmuted first, then muted if it fails
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
          playPromise.then(() => {
            updatePlayPauseButton(video, playPauseBtn);
          }).catch(() => {
            // Try muted autoplay as fallback
            if (!video.muted) {
              video.muted = true;
              const mutedPlayPromise = video.play();
              
              if (mutedPlayPromise !== undefined) {
                mutedPlayPromise.then(() => {
                  updatePlayPauseButton(video, playPauseBtn);
                  if (muteBtn) updateMuteButton(video, muteBtn);
                  
                  // Show controls so user can unmute
                  const controls = wrapper.querySelector('.video-controls');
                  if (controls) {
                    controls.style.opacity = '1';
                    controls.style.transition = 'opacity 0.3s ease';
                  }
                }).catch(() => {
                  showAutoplayFailedState();
                });
              }
            } else {
              showAutoplayFailedState();
            }
            
            function showAutoplayFailedState() {
              // If autoplay fails completely, show controls permanently
              video.pause();
              const controls = wrapper.querySelector('.video-controls');
              if (controls) {
                controls.style.opacity = '1';
                controls.style.transition = 'none';
                controls.style.animation = 'pulse 2s infinite';
              }
              updatePlayPauseButton(video, playPauseBtn);
            }
          });
        }
      } else {
        // Ensure proper initial state for non-autoplay videos
        updatePlayPauseButton(video, playPauseBtn);
      }
    });
  }
  
  function setupIntersectionObserver(video, wrapper) {
    // Create intersection observer to auto-play when video enters viewport
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Video is in viewport, try to play it
            if (video.paused && !video.dataset.userPaused) {
              video.muted = true; // Ensure muted for autoplay
              video.play().catch(() => {
                // Silent error handling if autoplay fails
              });
            }
          } else {
            // Video is out of viewport, pause it (unless user explicitly played it)
            if (!video.paused && !video.dataset.userPlaying) {
              video.pause();
            }
          }
        });
      }, {
        threshold: 0.5, // Play when 50% of video is visible
        rootMargin: '0px'
      });
      
      observer.observe(wrapper);
      
      // Track user interactions to respect user intent
      const playPauseBtn = wrapper.querySelector('.play-pause-btn');
      if (playPauseBtn) {
        playPauseBtn.addEventListener('click', () => {
          if (video.paused) {
            video.dataset.userPlaying = 'true';
            delete video.dataset.userPaused;
          } else {
            video.dataset.userPaused = 'true';
            delete video.dataset.userPlaying;
          }
        });
      }
      
      // Also track clicks on video itself
      video.addEventListener('click', () => {
        if (video.paused) {
          video.dataset.userPlaying = 'true';
          delete video.dataset.userPaused;
        } else {
          video.dataset.userPaused = 'true';
          delete video.dataset.userPlaying;
        }
      });
    }
  }
  
  function updatePlayPauseButton(video, button) {
    if (!button) return;
    
    const playIcon = button.querySelector('.play-icon');
    const pauseIcon = button.querySelector('.pause-icon');
    
    if (video.paused) {
      if (playIcon) playIcon.style.display = 'block';
      if (pauseIcon) pauseIcon.style.display = 'none';
      button.setAttribute('aria-label', 'Play video');
    } else {
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'block';
      button.setAttribute('aria-label', 'Pause video');
    }
  }
  
  function updateMuteButton(video, button) {
    if (!button) return;
    
    const unmuteIcon = button.querySelector('.unmute-icon');
    const muteIcon = button.querySelector('.mute-icon');
    
    if (video.muted) {
      if (unmuteIcon) unmuteIcon.style.display = 'none';
      if (muteIcon) muteIcon.style.display = 'block';
      button.setAttribute('aria-label', 'Unmute video');
    } else {
      if (unmuteIcon) unmuteIcon.style.display = 'block';
      if (muteIcon) muteIcon.style.display = 'none';
      button.setAttribute('aria-label', 'Mute video');
    }
  }
  
  // Initialize on DOM load and when sections are loaded
  function safeInit() {
    try {
      initVideoControls();
    } catch (error) {
      // Silent error handling
    }
  }
  
  // Try autoplay for all videos after user interaction
  function enableAutoplayAfterInteraction() {
    const videos = document.querySelectorAll('.images-with-text-scroll__video[autoplay]');
    videos.forEach(video => {
      if (video.paused && video.hasAttribute('autoplay')) {
        video.play().catch(() => {
          // Silent error handling
        });
      }
    });
  }
  
  // Initialize on DOM load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    // DOM is already loaded, wait a bit to ensure sections are rendered
    setTimeout(safeInit, 100);
  }
  
  // Re-initialize if new content is dynamically loaded
  document.addEventListener('shopify:section:load', safeInit);
  
  // Also try to initialize when the window loads (as backup)
  window.addEventListener('load', safeInit);
  
  // Try to enable autoplay after first user interaction
  let interactionOccurred = false;
  ['click', 'touchstart', 'scroll', 'keydown'].forEach(event => {
    document.addEventListener(event, function() {
      if (!interactionOccurred) {
        interactionOccurred = true;
        setTimeout(enableAutoplayAfterInteraction, 500);
      }
    }, { once: true, passive: true });
  });
})();